import { useEffect } from "react";
import { initGoogleAds } from "../lib/googleAds";

/**
 * GoogleAdsLoader — pre-warms the runtime Google Ads config (fetched from
 * GET /api/site/google-ads, set in Admin → Marketing → Google Ads) and
 * issues the extra `gtag('config', AW-XXXX)` call so remarketing + page
 * signals start flowing. Conversion events themselves are fired by the
 * relevant pages via lib/googleAds.js (purchase on Success, quote on the
 * design-quote modal). Idempotent — safe to mount once at app root.
 *
 * The base gtag/js script is already injected in public/index.html (GA4);
 * Google Ads reuses the exact same script, so there's nothing to inject.
 */
export default function GoogleAdsLoader() {
  useEffect(() => {
    initGoogleAds();
  }, []);
  return null;
}
